import React from "react";
import { Icon } from "@iconify/react";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";

function PermissionRestriced() {
  const { buttonClass } = useButtonTableStyle();
  return (
    <div id="main-wrapper">
      <div className="position-relative overflow-hidden min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="row justify-content-center w-100">
            <div className="col-lg-4">
              <div className="text-center">
                <div className="d-inline-block p-4 rounded-circle bg-danger bg-opacity-10 mb-4">
                  <Icon
                    icon="solar:shield-cross-bold"
                    className="text-danger"
                    width="48"
                    height="48"
                  />
                </div>
                <h1 className="fw-semibold mb-3 fs-9">Access Denied</h1>
                <p className="text-muted mb-4">
                  You don't have the required permissions to access this page.
                  Please contact your administrator if you believe this is a
                  mistake.
                </p>

                <div className="d-flex align-items-center justify-content-center gap-2 text-muted mb-4">
                  <span>Need access? Contact your administrator at </span>
                  <a
                    href="mailto:admin@email.com"
                    className="text-danger text-decoration-none fw-medium"
                  >
                    admin@email.com
                  </a>
                </div>

                <div className="d-flex gap-2 justify-content-center">
                  <button
                    className={`btn btn-danger ${buttonClass}`}
                    onClick={() => window.history.back()}
                    role="button"
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PermissionRestriced;
